import { render, staticRenderFns } from "./RiskDiagnosisDocumentPage.vue?vue&type=template&id=3864d748"
import script from "./RiskDiagnosisDocumentPage.vue?vue&type=script&lang=js"
export * from "./RiskDiagnosisDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports